import React, { useState, useEffect } from 'react';
import DateInput from './DateInput';

// (임시 CSS - 변경 없음)
const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', padding: '20px', borderRadius: '8px',
    width: '90%', maxWidth: '500px'
  },
  inputRow: { display: 'flex', gap: '10px', marginBottom: '15px', alignItems: 'center' },
  dateInput: { flex: 2, padding: '8px' },
  hourInput: { flex: 1, padding: '8px' },
  addButton: { padding: '8px 12px', cursor: 'pointer', background: '#007bff', color: 'white', border: 'none' },
  list: { listStyle: 'none', padding: 0, maxHeight: '200px', overflowY: 'auto', border: '1px solid #eee', padding: '10px' },
  listItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', borderBottom: '1px solid #f0f0f0' },
  removeButton: { background: '#dc3545', color: 'white', border: 'none', cursor: 'pointer', padding: '2px 6px', borderRadius: '4px' },
  buttons: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  saveButton: { padding: '8px 12px', cursor: 'pointer', background: '#28a745', color: 'white', border: 'none' },
  cancelButton: { padding: '8px 12px', cursor: 'pointer', background: '#6c757d', color: 'white', border: 'none' }
};

// ⬇️ [3순위 수정] onDetailsChange prop 추가
const LeaveUseModal = ({ isOpen, onClose, onSave, onDetailsChange, currentLeaveDetails = [], leaveRecordId, version, isMonthClosed }) => {
  const [details, setDetails] = useState(currentLeaveDetails);
  const [newDate, setNewDate] = useState('');
  const [newHours, setNewHours] = useState(0);

  useEffect(() => {
    setDetails(currentLeaveDetails); 
  }, [currentLeaveDetails, isOpen]); 

  if (!isOpen) return null;

  // 항목 추가
  const handleAddItem = () => {
    if (newDate && newHours > 0) {
      const newItem = { date: newDate, hours: parseFloat(newHours) };
      const newDetails = [...details, newItem].sort((a, b) => a.date.localeCompare(b.date));
      setDetails(newDetails); 
      setNewDate('');
      setNewHours(0);
      
      // ⬇️ [3순위 추가] 변경사항을 즉시 Page로 전파
      if (onDetailsChange) onDetailsChange(newDetails);
    }
  };

  // 항목 제거
  const handleRemoveItem = (index) => {
    const newDetails = details.filter((_, i) => i !== index);
    setDetails(newDetails);
    
    // ⬇️ [3순위 추가] 변경사항을 즉시 Page로 전파
    if (onDetailsChange) onDetailsChange(newDetails);
  };

  // 총 사용 시간 계산
  const totalHours = details.reduce((sum, item) => sum + item.hours, 0);

  // 저장
  const handleSave = () => {
    onSave(leaveRecordId, { 
      usedLeaveDetails: details,
      version: version 
    });
    onClose(); 
  };

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px'}}>
            <h3>연차 사용 날짜/시간 관리</h3>
            <span style={{fontSize: '0.8rem', color: '#666'}}>Version: {version}</span> 
        </div>
        
        <div style={modalStyles.inputRow}>
          <DateInput value={newDate} onChange={setNewDate} style={{ flex: 2 }} inputStyle={{ padding: '8px' }} disabled={isMonthClosed} />
          <input
            type="number"
            placeholder="시간"
            style={modalStyles.hourInput}
            value={newHours}
            onChange={(e) => setNewHours(e.target.value)}
            step="1"
            min="1"
            disabled={isMonthClosed}
          />
          <button 
            type="button" 
            style={modalStyles.addButton} 
            onClick={handleAddItem}
            disabled={isMonthClosed}
          >
            추가
          </button>
        </div>
        
        <p style={{fontWeight: 'bold', marginTop: '10px'}}>총 {totalHours} 시간 사용</p>
        <ul style={modalStyles.list}>
          {details.length > 0 ? details.map((item, index) => (
            <li key={index} style={modalStyles.listItem}>
              <span>{item.date} ({item.hours}시간)</span>
              <button 
                style={modalStyles.removeButton} 
                onClick={() => handleRemoveItem(index)}
                disabled={isMonthClosed}
              >
                삭제
              </button>
            </li>
          )) : (
            <li>사용 내역이 없습니다.</li>
          )}
        </ul>

        <div style={modalStyles.buttons}>
          <button type="button" style={modalStyles.cancelButton} onClick={onClose}>취소</button>
          <button 
            type="button" 
            style={modalStyles.saveButton} 
            onClick={handleSave}
            disabled={isMonthClosed}
          >
            저장하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveUseModal;